module.exports = __webpack_public_path__ + "img/bz.e6b5e204.svg";